module.exports = __webpack_public_path__ + "static/media/messenger_icon.9549e110.svg";